import { ProethicaPrinciplesExplorer } from "@features/proethica-principles";
import type { ProethicaPrinciple } from "@features/proethica-principles";

interface Props {
	principles: ProethicaPrinciple[];
	inReview?: boolean;
}

const PrinciplesAccordion = ({ principles, inReview }: Props) => (
	<ProethicaPrinciplesExplorer principles={principles} inReview={inReview} />
);

export default PrinciplesAccordion;
